import axios from 'axios'

const state = {
  photos: [],
  jobs: [],
  projects: [],
  qcPhotos: [],
  saPhotos: [],
}

const getters = {
  getProjects () {
    const uniqueProjects = [...new Set(state.projects.map(project => ({ id: project.project_id, name: project.project_name })))]
    return uniqueProjects
  },
  getJobs () {
    const uniqueJobs = [...new Set(state.jobs.map(job => ({ id: job.job_id, name: job.job_name })))]
    return uniqueJobs
  },
}

const mutations = {
  setPhotos (state, photos) {
    state.photos = photos
  },
  setQCPhotos (state, photos) {
    state.qcPhotos = photos
  },
  setJobs (state, jobs) {
    state.jobs = jobs
  },
  setProjects (state, projects) {
    state.projects = projects
  },
  updatePhotos (state, payload) {
    payload.forEach(photo => {
      const index = state.photos.findIndex(item => item.id === photo.id)
      if (index !== -1) state.photos.splice(index, 1, photo)
    })
  },
  updateQc (state, payload) {
    payload.forEach(photo => {
      const index = state.qcPhotos.findIndex(item => item.id === photo.id)
      if (index !== -1) state.qcPhotos.splice(index, 1, photo)
    })
  }
}

const actions = {
  getPhotosList (context) {
    return axios.get('/api/photos/get_photos/')
      .then(response => {
        context.commit('setPhotos', response.data)
      })
      .catch(e => { console.log(e) })
  },
  getJobList (context) {
    return axios.get('/api/photos/jobs/')
      .then(response => {
        context.commit('setJobs', response.data)
      })
      .catch(e => { console.log(e) })
  },
  getProjectList (context) {
    return axios.get('/api/photos/projects/')
      .then(response => {
        context.commit('setProjects', response.data)
      })
      .catch(e => { console.log(e) })
  },

  bulkUpdate (context, payload) {
    return axios.post('/api/photos/bulk_update/', payload).then(response => {
      if (payload.isQc) {
        context.commit('updateQc', response.data)
      } else {
        context.commit('updatePhotos', response.data)
      }
    })
      .catch(e => { console.log(e) })
  },
  clearAssignedPhotos (context) {
    return axios.post('/api/photos/clear_assigned/').then(response => {
    })
      .catch(e => { console.log(e) })
  },
  submitAssigned (context, payload) {
    return axios.post('/api/photos/submit_assigned/', payload).then(response => {
    })
      .catch(e => { console.log(e) })
  },
  submitQCAssigned (context, payload) {
    return axios.post('/api/photos/submit_qc_assigned/', payload).then(response => {
    })
      .catch(e => { console.log(e) })
  },
  submitCounts (context, payload) {
    return axios.post('/api/photos/submit_counts/', payload)
      .then(response => {
        if (payload.is_qc) {
          context.commit('updateQc', [response.data])
        } else {
          context.commit('updatePhotos', [response.data])
        }
        return response.data
      })
  },
  bulkSubmitCounts (context, payload) {
    return axios.post('/api/photos/bulk_submit_counts/', payload)
      .then(response => {
        if (payload.is_qc) {
          context.commit('updateQc', response.data)
        } else {
          context.commit('updatePhotos', response.data)
        }
        return response.data
      })
      .catch(e => { console.log(e) })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
